import React from 'react';
import '../styles/TextPage.css';
import { useTranslation } from 'react-i18next';


const ResponsibleGame = () => (
  <div className="PrivacyInfo__description" style={{ color: '#fff' }}>
    <span className="InfoHeader">Ответственная игра</span>
    <p>
      Ответственная игра является важной частью политики обслуживания клиентов нашей Компании, поэтому мы очень серьезно подходим к проблемам, которые могут возникнуть в результате зависимости от азартных игр. Мы считаем своей прямой обязанностью защищать игроков от неумеренного пристрастия к игре и не допускать участия несовершеннолетних в азартных играх.
    </p>
    <p>
      Мы хотим, чтобы наш сервис был максимально удобным и функциональным, чтобы он отлично подходил для увлекательного времяпрепровождения. К сожалению, для некоторых игроков азартная игра может из захватывающего хобби превратиться в проблему.
    </p>
    <p>
      Мы полностью поддерживаем и разделяем используемую во всем мире политику ответственных азартных игр, а также делаем все для того, чтобы наши Клиенты могли наслаждаться безопасной и захватывающей игрой, не теряя контроль.
    </p>
    <div style={{ fontWeight: 700, fontSize: 16, margin: '18px 0 8px', color: '#fff' }}>Сохранение контроля</div>
    <p>
      Азартная игра в букмекерской конторе — это просто развлечение, хороший способ приятно провести время, насладиться игрой любимой команды и найти единомышленников среди других участников пари. Приятно проводя время за просмотром матчей и азартной игрой, тем не менее, стоит помнить о том, что необходимо соблюдать меру.
    </p>
    <p>Каждый участник пари всегда должен помнить:</p>
    <ul style={{ paddingLeft: 24 }}>
      <li>азартные игры — это лишь форма досуга, а не способ зарабатывания денег, нельзя терять чувство меры:</li>
      <ul style={{ paddingLeft: 24 }}>
        <li>в случае проигрыша не следует предпринимать попытки немедленно отыграться, потому что всегда есть шанс выиграть в следующий раз;</li>
        <li>начинайте игру при условии, что вы сможете потратить только имеющуюся у вас сумму и не более того;</li>
        <li>внимательно следите за временем и количеством денег, которые вы тратите на игру.</li>
      </ul>
    </ul>
    <div style={{ fontWeight: 700, fontSize: 16, margin: '18px 0 8px', color: '#fff' }}>Предупреждение игровой зависимости.</div>
    <p>
      Среди большинства людей, для которых азартная игра является лишь увлекательным способом провести время, существует небольшой процент игроков, которые страдают от игровой зависимости. Результаты последних исследований показали, что только незначительная часть взрослого населения сталкивается с такой проблемой, как игровая зависимость. Однако наша Компания относится к этой проблеме со всей серьезностью и предлагает участникам пари всегда помнить, что:
    </p>
    <ul style={{ paddingLeft: 24 }}>
      <li>азартные игры основаны на законе вероятности, поэтому не существует никаких “формул” и “систем”, гарантирующих выигрыш;</li>
      <li>желание играть должно исходить исключительно от вас;</li>
      <li>азартная игра — это развлечение, а не способ быстрого обогащения или оплаты долгов;</li>
      <li>регулярно следите за тем, сколько денег вы тратите на игру;</li>
      <li>чтобы играть, всегда необходимо знать правила игры.</li>
    </ul>
    <p>Сложно определить грань, которая разделяет здоровый азарт и болезненное пристрастие. Но существуют некоторые признаки, которые могут свидетельствовать о том, что у участника пари начинаются проблемы.</p>
    <p>Вам предлагается ответить на 10 вопросов. Если хотя бы на 5 из них вы ответили утвердительно, то велика вероятность того, что вы уже страдаете игровой зависимостью.</p>
    <ul style={{ paddingLeft: 24 }}>
      <li>Вы серьезно вовлечены в азартные игры?</li>
      <li>Суммы ваших пари постоянно увеличиваются?</li>
      <li>Вы берете деньги взаймы, чтобы играть?</li>
      <li>Вы часто играете дольше, чем планировали?</li>
      <li>Частое посещение букмекерской конторы негативно сказывается на вашей репутации?</li>
      <li>Вы испытываете раздражение или разочарование, если не можете принять участие в пари?</li>
      <li>Участие в азартных играх является для вас способом уйти от проблем?</li>
      <li>Вам часто приходится отыгрываться?</li>
      <li>Вы пытались контролировать размер сумм пари, время нахождения в игорном заведении, но попытки оказались безуспешными?</li>
      <li>Вы не говорите о своем увлечении азартными играми близким?</li>
    </ul>
    <div style={{ fontWeight: 700, fontSize: 16, margin: '18px 0 8px', color: '#fff' }}>Советы по управлению игрой</div>
    <ul style={{ paddingLeft: 24 }}>
      <li>Заранее определите для себя время, которое вы потратите на игру в букмекерской компании;</li>
      <li>Установите для себя максимальную сумму, которую вы готовы проиграть, и не превышайте ее; Никогда не берите взаймы деньги, чтобы поиграть в азартные игры;</li>
      <li>Попробуйте найти себе новое хобби и сочетайте его с игрой;</li>
      <li>Никогда не посещайте игорные заведения, если у вас плохое настроение, подавленное или угнетенное состояние.</li>
    </ul>
    <div style={{ fontWeight: 700, fontSize: 16, margin: '18px 0 8px', color: '#fff' }}>Самоисключение из игры</div>
    <p>
      Если вы хотите закрыть свою учетную запись 1win, пожалуйста, свяжитесь со службой поддержки. В большинстве случаев у вас будет возможность восстановить учетную запись позже. Однако если вы потребуете окончательного закрытия, мы удовлетворим эту просьбу при любых обстоятельствах и возобновление учетной записи будет невозможно.
    </p>
    <div style={{ fontWeight: 700, fontSize: 16, margin: '18px 0 8px', color: '#fff' }}>Дополнительная помощь онлайн</div>
    <p>Некоторые благотворительные организации и ассоциации могут предоставить помощь и советы по адресам:</p>
    <ul style={{ paddingLeft: 24 }}>
      <li><a href="https://www.gamblingtherapy.org/" target="_blank" rel="noopener noreferrer" style={{ color: '#4faaff' }}>https://www.gamblingtherapy.org/</a></li>
      <li><a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#4faaff' }}>https://www.gamcare.org.uk</a></li>
      <li><a href="https://www.gamblersanonymous.org.uk/" target="_blank" rel="noopener noreferrer" style={{ color: '#4faaff' }}>https://www.gamblersanonymous.org.uk/</a></li>
    </ul>
  </div>
);

export default ResponsibleGame;


